module.exports = "<div class=\"dialog-header\" *ngIf=\"titre != null\">\n    <h3 class=\"cerba-h3\">{{titre | translate}}</h3>\n</div>\n<div class=\"dialog-content\">\n    <asi-fa-icon icon=\"fa-spin fa-spinner\" size=\"5x\"></asi-fa-icon>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/modal/waiting/waiting.modal.html
// module id = ../../../../../../../../../../digicerba-common-module/src/components/modal/waiting/waiting.modal.html
// module chunks = 1